import MobileNavView from "components/shared/views/MobileNavView";
import AccountDetailsModal from "./AccountDetailsModal";
import ChatEndSessionModal from "./ChatEndSessionModal";
import DeleteEmailModal from "./DeleteEmailModal";
import DeletePhoneModal from "./DeletePhoneModal";
import FirstTimeLoginModal from "./FirstTimeLoginModal";
import MakeAPaymentModal from "./MakeAPaymentModal";
import ReviewTransferModal from "./ReviewTransferModal";
import TestModal from "./TestModal";
import AddContactMethodModal from "./AddContactMethodModal";
import CheckImagePreviewModal from "components/custom-ui/FullPageModal/components/CheckImagePreviewModal";
import MobileAccountDetailsModal from "./MobileAccountDetailsModal";
import OneTimeACHModal from "./OneTimeACHModal";
import ACHParticipantsModal from "./ACHParticipantsModal";
import PassThruACHDetailsModal from "./PassThruACHDetailsModal";

export default {
    "TestModal" : TestModal,
    "MakeAPaymentModal" : MakeAPaymentModal,
    "AccountDetailsModal" : AccountDetailsModal, 
    "ChatEndSessionModal" : ChatEndSessionModal, 
    "MobileNavView" : MobileNavView,
    "ReviewTransferModal" : ReviewTransferModal,
    "FirstTimeLoginModal" : FirstTimeLoginModal,
    "DeletePhoneModal" : DeletePhoneModal,
    "DeleteEmailModal" : DeleteEmailModal,
    "AddContactMethodModal" : AddContactMethodModal,
    "CheckImagePreviewModal" : CheckImagePreviewModal,
    "MobileAccountDetailsModal" : MobileAccountDetailsModal,
    "OneTimeACHModal": OneTimeACHModal,
    "ACHParticipantsModal": ACHParticipantsModal,
    "PassThruACHDetailsModal": PassThruACHDetailsModal,
};